import script from "./Nipp.vue?vue&type=script&setup=true&lang=ts"
export * from "./Nipp.vue?vue&type=script&setup=true&lang=ts"

import "./Nipp.vue?vue&type=style&index=0&id=cb0e3a3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nipp/nipp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb0e3a3c"]])

export default __exports__